import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";

import { db } from "../firebase";

import {
  doc,
  getDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [loading, setLoading] = useState(true);

  /* IMAGE MODAL */
  const [openImage, setOpenImage] = useState(null);

  /* REVIEWS */
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  /* FETCH PRODUCT */
  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);

      const docRef = doc(db, "products", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();

        setProduct(data);

        setMainImage(
          data.images?.[0] || data.image || ""
        );
      } else {
        setProduct(null);
      }

      setLoading(false);
    };

    fetchProduct();
  }, [id]);

  /* FETCH REVIEWS */
  useEffect(() => {
    const fetchReviews = async () => {
      const q = query(
        collection(db, "reviews"),
        where("productId", "==", id)
      );

      const snap = await getDocs(q);

      setReviews(
        snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    };

    fetchReviews();
  }, [id]);

  /* LOADING */
  if (loading) {
    return <h2>Loading product...</h2>;
  }

  /* PRODUCT NOT FOUND */
  if (!product) {
    return <h2>Product not found</h2>;
  }

  /* AVERAGE RATING */
  const averageRating = reviews.length
    ? (
        reviews.reduce(
          (sum, r) => sum + r.rating,
          0
        ) / reviews.length
      ).toFixed(1)
    : product.rating || 0;

  /* SUBMIT REVIEW */
  const handleReviewSubmit = async () => {
    if (!comment.trim()) {
      return alert("Write a review");
    }

    setSubmitting(true);

    try {
      await addDoc(collection(db, "reviews"), {
        productId: id,
        rating: Number(rating),
        comment,
        userName: "Guest User",
        createdAt: serverTimestamp(),
      });

      setComment("");
      setRating(5);

      const q = query(
        collection(db, "reviews"),
        where("productId", "==", id)
      );

      const snap = await getDocs(q);

      setReviews(
        snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    } catch (err) {
      console.log(err);
    }

    setSubmitting(false);
  };

  return (
    <div className="product-details">

      {/* IMAGE SECTION */}
      <div className="image-section">

        {/* MAIN IMAGE */}
        <img
          className="main-img"
          src={mainImage}
          alt={product.name}
          onClick={() => setOpenImage(mainImage)}
        />

        {/* THUMBNAILS */}
        <div className="thumbnail-row">
          {(product.images || []).map((img, i) => (
            <img
              key={i}
              src={img}
              className="thumb"
              onClick={() => setMainImage(img)}
              alt=""
            />
          ))}
        </div>
      </div>

      {/* PRODUCT INFO */}
      <div className="info-section">

        <h1>{product.name}</h1>

        <p className="price">
          £{product.price}
        </p>

        <p className="rating">
          ({reviews.length} reviews)
        </p>

        {/* PRODUCT TAGS */}
        <div className="product-tags">
          <span>Fresh</span>
          <span>Fast Delivery</span>
          <span>Premium Quality</span>
        </div>

        <p className="desc">
          {product.description}
        </p>

      </div>

      {/* REVIEWS SECTION */}
      <div className="reviews-section">

        <h2>Customer Reviews</h2>

        {reviews.length === 0 ? (
          <p>No reviews yet</p>
        ) : (
          reviews.map((r) => (
            <div
              key={r.id}
              className="review-card"
            >
              ⭐ {r.rating}/5

              <p>{r.comment}</p>

              <small>{r.userName}</small>
            </div>
          ))
        )}

        {/* REVIEW FORM */}
        <div className="review-form">

          <h3>Write a review</h3>

          <select
            value={rating}
            onChange={(e) =>
              setRating(Number(e.target.value))
            }
          >
            <option value={5}>5 ⭐</option>
            <option value={4}>4 ⭐</option>
            <option value={3}>3 ⭐</option>
            <option value={2}>2 ⭐</option>
            <option value={1}>1 ⭐</option>
          </select>

          <textarea
            value={comment}
            onChange={(e) =>
              setComment(e.target.value)
            }
            placeholder="Write your review..."
          />

          <button
            onClick={handleReviewSubmit}
            disabled={submitting}
          >
            {submitting
              ? "Submitting..."
              : "Submit Review"}
          </button>

        </div>
      </div>

      {/* IMAGE MODAL */}
      {openImage && (
        <div
          className="image-modal"
          onClick={() => setOpenImage(null)}
        >
          <img
            src={openImage}
            alt="Full view"
          />
        </div>
      )}
    </div>
  );
};

export default ProductDetails;